(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var targets = document.querySelectorAll('[data-jangin-reveal], [data-jangin-reveal-stagger]');

  if (reducedMotion) {
    targets.forEach(function (el) { el.classList.add('is-revealed'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -5% 0px' });

  // If an element is already at least partially inside the real viewport
  // on first paint, reveal it immediately — don't make the user scroll
  // past the -18% rootMargin threshold to see content that's in plain sight
  // (e.g., the footer on a short page, hero content below a short above-fold).
  var viewportH = window.innerHeight || document.documentElement.clientHeight;
  targets.forEach(function (el) {
    var rect = el.getBoundingClientRect();
    if (rect.top < viewportH && rect.bottom > 0) {
      el.classList.add('is-revealed');
    } else {
      observer.observe(el);
    }
  });
})();
